/* global DEBUG_NEXT */

/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { Fullscreen } from 'next/components/ui';
import { selectFeatures, NEXT_FLOWS_LIST_PAGE } from 'next/entities/features';

/**
 * Shareable route registry
 *
 * NOTE: In the future, we can inline the parameters directly as props to
 *       <Route>, but since we need to create conditional passthrough routes in
 *       legacy studio as well, we need to define these routes in a way it can
 *       be consumed in multiple places
 */
export const routes = [
  /**
   * XXX: Example route that shows a conditional route based on arbitrary such
   *      as environment variables. This particular route is only accessible
   *      during local development.
   */
  {
    ungated: DEBUG_NEXT,
    path: '/development',
    render: () => {
      return <Fullscreen>Development route...</Fullscreen>;
    },
  },

  /**
   * XXX: Example route that shows a conditional route based on feature flags
   *      from e.g. LaunchDarkly. This particular route is accessible if the
   *      feature flag for the new flows list page is enabled.
   */
  {
    feature: NEXT_FLOWS_LIST_PAGE,
    path: '/flows',
    render: () => {
      return <Fullscreen>Future flows list route...</Fullscreen>;
    },
  },
];

/**
 * Filter accessible routes based on feature flags
 *
 * @param {Route[]} registry - List of registered routes
 * @param {object<boolean>} features - Map of feature flags
 * @return {Route[]} Filtered list of routes
 */
export const filter = (registry = [], features = {}) =>
  registry.filter(({ feature, ungated }) => ungated ?? features[feature]);

/**
 * Top-level routes for studio next
 */
export function Routes({ features = {}, routes: registry = routes }) {
  const accessible = filter(registry, features);

  return (
    <Switch>
      {accessible.map(({ path, ...rest }) => (
        <Route key={path} path={path} {...rest} />
      ))}
    </Switch>
  );
}

Routes.propTypes = {
  features: PropTypes.objectOf(PropTypes.bool),
  routes: PropTypes.shape({
    ...Route.propTypes,
    feature: PropTypes.bool,
    ungated: PropTypes.bool,
  }),
};

const mapStateToProps = state => ({
  features: selectFeatures(state),
});

export default connect(mapStateToProps)(Routes);
